module.exports = __webpack_public_path__ + "img/iap-logo.43efff73.png";